import { ZonedDateTime } from '@internationalized/date';

export const TaskType = {
  Pickup: 'Pickup',
  Delivery: 'Delivery',
  Fill: 'Fill',
  Empty: 'Empty',
  Reposition: 'Reposition',
} as const;

export type TaskType = (typeof TaskType)[keyof typeof TaskType];

export const TaskStatus = {
  Planned: 'Planned',
  Active: 'Active',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
} as const;

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];

export interface TaskRecord {
  id: string;
  type: TaskType;
  status: TaskStatus;
  fulfillmentServiceId: string;
  sourceServiceId?: string;
  accountId?: string;
  accountAddressId?: string;
  facilityId?: string;
  routeId?: string;
  routePosition?: number;
  assetId?: string;
  assetTypeId?: string;
  assetGroup?: number;
  startedAt?: ZonedDateTime;
  completedAt?: ZonedDateTime;
  timestamps: {
    createdAt: ZonedDateTime;
    updatedAt: ZonedDateTime;
  };
}
